import * as React from "react"
import Svg, { G, Circle, Path } from "react-native-svg"

export const SvgLogoWhite = (props) => (

    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.391001mm"
      height="10.719mm"
      viewBox="0 0 30.391001 10.719"
      {...props}
    >
      <Path
        d="M25.793 0s3.68.161 2.99 1.265c-.69 1.104-6.027 9.454-6.027 9.454h2.347l4.44-9.264-4.118 9.264h2.438c1.189-4.424 1.733-6.406 2.501-9.19C30.796-.035 25.793 0 25.793 0z"
        fill="#fff"
        fillOpacity={1}
        stroke="none"
        strokeWidth=".368032px"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity={1}
      />
      <G fill="#fff" fillOpacity={1} stroke="#fff" strokeOpacity={1}>
        <Path
          d="M103.05 125.444v-.544H98.113v-9.206h-1.339v10.294h6.278z"
          transform="matrix(.80253 0 0 .80253 -77.664 -91.62)"
          fill="#fff"
          strokeWidth={0.0836965}
          fillOpacity={1}
          stroke="#fff"
          strokeOpacity={1}
        />
        <Path
          d="M105.406 122.19c.017.274.049.53.123.795.08.283.163.552.311.806.125.212.302.437.476.611.203.204.38.34.64.463.23.11.42.18.65.214.107.017.23.022.365.022.082 0 .165 0 .226-.005.165-.012.332-.025.491-.07a2.96 2.96 0 00.691-.297 2.086 2.086 0 00.757-.781c.084-.158.136-.334.173-.509.047-.217.063-.71.063-.71h1.355s.005.632-.066.938a3.036 3.036 0 01-.364.893 2.973 2.973 0 01-.579.67c-.218.19-.47.345-.727.479a4.295 4.295 0 01-1.443.416c-.34.034-.684.035-1.023 0a4.062 4.062 0 01-.824-.17 3.377 3.377 0 01-.661-.292 3.8 3.8 0 01-.702-.514 3.707 3.707 0 01-.49-.59 4.686 4.686 0 01-.428-.743 3.956 3.956 0 01-.228-.673 7.056 7.056 0 01-.157-.97c-.026-.245-.03-.491-.036-.737v-1.19c.006-.246.01-.492.036-.737.034-.326.078-.652.157-.97.058-.23.131-.457.228-.673.118-.26.264-.508.427-.742.146-.21.305-.415.491-.59a3.8 3.8 0 01.702-.515c.208-.12.431-.219.66-.292.268-.086.546-.142.825-.17.34-.034.684-.034 1.023 0a4.295 4.295 0 011.443.416c.258.134.51.288.727.48.222.194.425.418.58.67.167.274.29.58.363.892.071.306.066.939.066.939h-1.355s-.016-.494-.063-.711a1.951 1.951 0 00-.173-.509 2.086 2.086 0 00-.757-.781 2.96 2.96 0 00-.69-.297 2.455 2.455 0 00-.492-.07 3.809 3.809 0 00-.591.017 2.23 2.23 0 00-.65.214c-.26.123-.437.259-.64.463-.174.174-.351.399-.476.611-.148.254-.232.523-.31.806-.075.265-.107.52-.124.795-.032.53-.029 1.349-.029 1.349s-.003.82.03 1.349zM114.56 122.19c.016.274.048.53.122.795.08.283.163.552.311.806.125.212.301.437.476.611.203.204.38.34.64.463.23.11.42.18.65.214.106.017.23.022.365.022.081 0 .165 0 .226-.005.165-.012.332-.025.491-.07a2.96 2.96 0 00.691-.297 2.087 2.087 0 00.757-.781c.084-.158.135-.334.173-.509.047-.217.063-.71.063-.71h1.355s.005.632-.066.938a3.036 3.036 0 01-.364.893 2.973 2.973 0 01-.579.67c-.218.19-.47.345-.727.479a4.294 4.294 0 01-1.443.416c-.34.034-.684.035-1.023 0a4.062 4.062 0 01-.825-.17 3.377 3.377 0 01-.66-.292 3.8 3.8 0 01-.702-.514 3.707 3.707 0 01-.49-.59 4.686 4.686 0 01-.428-.743 3.956 3.956 0 01-.228-.673 7.056 7.056 0 01-.158-.97c-.025-.245-.029-.491-.035-.737v-1.19c.006-.246.01-.492.035-.737.035-.326.079-.652.158-.97.057-.23.13-.457.228-.673.118-.26.264-.508.427-.742.146-.21.305-.415.491-.59a3.8 3.8 0 01.702-.515c.208-.12.431-.219.66-.292.268-.086.546-.142.825-.17.34-.034.684-.034 1.023 0a4.295 4.295 0 011.443.416c.257.134.51.288.727.48.222.194.425.418.58.67.167.274.29.58.363.892.071.306.066.939.066.939h-1.355s-.016-.494-.063-.711a1.951 1.951 0 00-.174-.509 2.086 2.086 0 00-.756-.781 2.96 2.96 0 00-.691-.297 2.455 2.455 0 00-.49-.07 3.81 3.81 0 00-.593.017 2.23 2.23 0 00-.649.214c-.26.123-.437.259-.64.463-.175.174-.351.399-.476.611-.148.254-.232.523-.311.806-.074.265-.106.52-.123.795-.032.53-.029 1.349-.029 1.349s-.003.82.03 1.349z"
          transform="matrix(.80253 0 0 .80253 -77.664 -91.62)"
          fill="#fff"
          fillOpacity={1}
          stroke="#fff"
          strokeWidth={0.1}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={4}
          strokeDasharray="none"
          strokeOpacity={1}
        />
      </G>
    </Svg>
  )



